module.exports = __webpack_public_path__ + "files/c4d7e5d85ad4417f275d8eb4240fc09c.png";